import { isInDingTalk } from "../../assets/js/utils/ding-env";
import { gantConf } from "../../assets/js/utils/jurisdiction";

// 控制台权限菜单
export const consoleMenus = [
  {
    pid: gantConf.memberManage,
    name: isInDingTalk ? "组织及权限" : "组织及权限",
    path: "/console/member",
    tip:
      "通过手机号码邀请成员，成员收到短信验证身份后即可加入。成员离职可移除成员，邀请新的成员。",
    children: [
      {
        pid: 7,
        name: "组织管理",
        path: "/console/organization",
        tip:
          "添加组织，实现企业分公司、部门等管理需求。设置部门主管用于文件发起的审批流程。"
      },
      {
        pid: [8, 9], // 包含角色权限，角色分配
        name: "角色管理",
        path: "/console/role",
        tip:
          "给企业管理者分配管理角色，管理者可自行邀请成员，分配签章权限。"
      }
    ]
  },
  {
    pid: gantConf.sealManage,
    name: "印章及授权",
    path: "/console/seal",
    tip: "设置企业签章，将签章授权给成员，即可代表企业签署文件。",
    children: [{
      name: "添加用印审批",
      path: "/console/signApproval",
      query: {
        flowType: 1
      },
      match: {
        keys: ["flowType"],
        name: "编辑盖章审批" // 匹配成功后显示的title
      }
    },
    {
      name: "添加用印审批",
      path: "/console/dingComponents/Approval",
      query: {
        flowType: 1
      },
      match: {
        keys: ["flowType"],
        name: "编辑盖章审批" // 匹配成功后显示的title
      }
    }]
  },
  {
    pid: gantConf.approval,
    name: "成员合同审批",
    path: "/console/flow",
    tip: "设置审批流程，减少对外发出文件的风险。",
    children: [
      {
        name: "添加发起审批",
        path: "/console/approval",
        query: {
          flowType: 0
        },
        match: {
          keys: ["flowType"],
          name: "编辑发起审批" // 匹配成功后显示的title
        }
      },
      {
        name: "添加盖章审批",
        path: "/console/approval",
        query: {
          flowType: 1
        },
        match: {
          keys: ["flowType"],
          name: "编辑盖章审批" // 匹配成功后显示的title
        }
      }
    ]
  },
  {
    pid: gantConf.tempManage,
    name: isInDingTalk ? "模板管理" : "模板及授权",
    more: true,
    path: "/console/template",
    tip: "设置模板，将模板授权给成员，方便统一公司发起的文件内容规范。",
    isLink: true
  },
  // 【1609】放开操作日志审计菜单
  {
    pid: gantConf.auditLog,
    name: "操作日志审计",
    path: "/console/log",
    tip: "操作日志审计，方便追诉企业签章使用、后台成员设置等操作行为。"
  }
]
// 钉钉性能体验日志
export function ding_erformance () {
  if (isInDingTalk) {
    // 钉钉性能体验日志； 在需要的地方，调用 send 方法上报日志，通常在页面首屏依赖的接口请求完成且相关 DOM 渲染完成。
    const reportPerformance = () => {
      setTimeout(() => {
        const { send } = window.__BIRD || {};
        window.performance && window.performance.mark("FMP");
        typeof send === 'function' && send();
      }, 500); // 延迟500ms确保脚本初始化
    };

    if (document.readyState === 'complete') {
      // 页面已加载完成，直接执行
      reportPerformance();
    } else {
      // 页面还在加载，等待load事件
      window.addEventListener('load', reportPerformance);
    }
  }
}



// WEBPACK FOOTER //
// ./layouts/js/entConsoleDate.js